import { useTimeline } from './use-timeline';
export function useTimelineLength() {
  var timeline = useTimeline();
  return timeline.length;
}